import React, { useState, useEffect } from "react";
import { Row, Col, Label, Button, FormGroup, Input, InputGroup, InputGroupText } from 'reactstrap';
import ReactStrapTable from 'components/reactStrapTable';
import { toast } from 'react-toastify';
import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';
import Confirm from 'components/Confirm';
import { cellRendererCheck, currencyFormat, cellnumberFormat } from "utils/columns";
import Tooltip from 'react-tooltip-lite';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment/moment";
import Calendar from "assets/icon/calendar-icon.svg";

let checkedIds = [];
let allcheckids = [];
let statusdata = [];
let tostatusdata = [];
let hasDatePopupOpen = false;
let Startingyear;
let endingyear;
let StartingMonth;
let endingMonth;
let searchbutton = true;
let hiddencolum = false;

const BulkUpdateStatus = (props) => {

    const API = useAxios();

    const {
        manvalsearch,
        loader,
        data,
        bulkReset,
        statusloading,
        refetch } = props;

    const [toStatusList, setToStatusList] = useState([]);
    const [monthid, setmonth] = useState(endingMonth);
    const [yearvalue, setyear] = useState(endingyear);
    const [selectedIds, setSelectedIds] = useState([]);
    const [fmStatusID, setStatusID] = useState('-1');
    const [allCheckDefault, setAllCheckDefault] = useState(false);
    const [isConfirm, setConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validationerror, setValidationError] = useState('');
    const [cstatus, setCstatus] = useState(-1);
    const [tostatus, setTostatus] = useState(-1);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedyear, setSelectedYear] = useState(new Date());
    const [maxmont, setmaxmonth] = useState(new Date());

    useEffect(() => {
        checkedIds = [];
        setToStatusList([]);
        setAllCheckDefault(false);
    }, []);

    useEffect(() => {
        tostatusdata = [];
        searchbutton = true;
    }, []);

    useEffect(() => {
        fetchStatus();
    }, []);

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        };

        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        };
    };

    useEffect(() => {
        fetchGetEndingYearMonth();
    }, []);

    useEffect(() => {
        fetchStartingYearMonth();
    }, []);

    const fetchStartingYearMonth = async () => {

        setLoading(true);
        try {
            const { data } = await API.get('/search/startingyearmonth', {
                hasDefaultURL: false,
            });
            if (data) {
                Startingyear = data[0].year;
                StartingMonth = data[0].month;
            };
            setLoading(false)
        } catch (err) {
        };
    };

    const fetchGetEndingYearMonth = async () => {

        setLoading(true)
        try {
            const { data } = await API.get('/search/endingyearmonth', {
                hasDefaultURL: false,
            });
            if (data) {

                endingyear = data[0].year;
                endingMonth = data[0].month;
                setSelectedYear(new Date(endingyear, 11, 28))
                setyear(endingyear);
                setmonth(endingMonth);
                setSelectedDate(new Date(endingyear, endingMonth - 1, 28))
                setmaxmonth(new Date(endingyear, endingMonth - 1, 28))
            };
            setLoading(false)
        } catch (err) {
        };
    };

    const handelYear = (date) => {

        if (!date) return "";
        setSelectedDate();
        setSelectedYear(date)
        const year = moment(new Date(date)).format("YYYY");
        setyear(year);
        let currentyear = new Date().getFullYear();
        let yearvalue = parseInt(year);
        if (currentyear === yearvalue) {
            fetchStartingYearMonth();
            fetchGetEndingYearMonth();
            setmaxmonth(new Date(endingyear, endingMonth, 28));
            setSelectedDate(new Date(endingyear, endingMonth, 28));
        }
        else {
            let monthdata = new Date(endingyear, 11, 28);
            setmaxmonth(monthdata)
            setSelectedDate(monthdata)
            setmonth(12);
        };
    };

    const formatMonth = (date) => {
        setSelectedDate();
        if (!date) return "";
        setSelectedDate(date)
        const options = { month: "long" };
        const month = moment(new Date(date)).format("MM");
        const monthint = parseInt(month)
        setmonth(monthint)
    };



    const fetchStatus = async () => {

        statusdata = [];
        setLoading(true);
        try {
            const { data } = await API.get(`/search/status`, {
                hasDefaultURL: false,
            });
            if (data) {

                for (var x in data) {

                    statusdata.push({ "value": data[x].fmStatusID, "label": data[x].fmStatusDesc });
                };
            };
            setLoading(false);
        } catch (err) {
            setLoading(false);
        };
    };

    const fetchtoStatus = async (statusvalue) => {

        tostatusdata = [];
        setLoading(true);
        try {
            const { data } = await API.get(`/search/toStatus/${statusvalue}`, {
                hasDefaultURL: false,
            });
            if (data) {

                for (var x in data) {
                    tostatusdata.push({ "value": data[x].fmStatusID, "label": data[x].fmStatusDesc });
                };
            };
            setLoading(false);
        } catch (err) {
            setLoading(false);
        };
    };

    const handleAllCheckbox = (e) => {
        setAllCheckDefault(e.target.checked);
        checkedIds = [];

        if (e.target.checked) {
            allcheckids = [];
            if (allcheckids.length === 0) {
                for (var x in data) {
                    allcheckids.push(data[x].pfceInvoiceID);
                    checkedIds.push(data[x].pfceInvoiceID);
                }
                setSelectedIds([...allcheckids]);
            };
        }
        else {
            setSelectedIds([]);
            allcheckids = [];
            checkedIds = [];
        }
    };

    const cellrendertooltipcashcardfee = (row, value) => {

        if (row.cashCardFees === 0 && row.cashCardFeeNotes != null) {
            return (
                <Tooltip content={(
                    <div className='tip-list-info'>
                        <p>{row.cashCardFeeNotes}</p>
                    </div>
                )}
                    direction="down"
                    tagName="span"
                    className=""
                    style={{
                        display: "flex",
                        flex: "wrap"
                    }}
                    tipContentClassName=""
                    zIndex={9999}>
                    <span
                        className='cursor-pointer text-decoration-underline'
                    >
                        {currencyFormat(row.cashCardFees)}
                    </span>
                </Tooltip>)
        }
        else if (row.cashCardFees != 0 && row.cashCardFeeNotes == null) {
            return (
                currencyFormat(row.cashCardFees)
            )
        }
        else if (row.cashCardFees != 0 && row.cashCardFeeNotes != null) {
            return (
                <Tooltip content={(
                    <div className='tip-list-info'>
                        <p>{row.cashCardFeeNotes}</p>
                    </div>
                )}
                    direction="down"
                    tagName="span"
                    className=""
                    style={{
                        display: "flex",
                        flex: "wrap"
                    }}
                    tipContentClassName=""
                    zIndex={9999}>
                    <span
                        className='cursor-pointer text-decoration-underline'
                    >
                        {currencyFormat(row.cashCardFees)}
                    </span>
                </Tooltip>)
        }
        else {
            if (!value) return '-';
            return value;
        };
    };
    const cellrendertooltipalternatefee = (row, value) => {

        if (row.ceAdjustments === 0 && row.flatFeeNotes != null) {
            return (
                <Tooltip content={(
                    <div className='tip-list-info'>
                        <p>{row.flatFeeNotes}</p>
                    </div>
                )}
                    direction="down"
                    tagName="span"
                    className=""
                    style={{
                        display: "flex",
                        flex: "wrap"
                    }}
                    tipContentClassName=""
                    zIndex={9999}>
                    <span
                        className='cursor-pointer text-decoration-underline'
                    >
                        {currencyFormat(row.ceAdjustments)}
                    </span>
                </Tooltip>)
        }
        else if (row.ceAdjustments != 0 && row.flatFeeNotes == null) {
            return (
                currencyFormat(row.ceAdjustments)
            )
        }
        else if (row.ceAdjustments != 0 && row.flatFeeNotes != null) {
            return (
                <Tooltip content={(
                    <div className='tip-list-info'>
                        <p>{row.flatFeeNotes}</p>
                    </div>
                )}
                    direction="down"
                    tagName="span"
                    className=""
                    style={{
                        display: "flex",
                        flex: "wrap"
                    }}
                    tipContentClassName=""
                    zIndex={9999}>
                    <span
                        className='cursor-pointer text-decoration-underline'
                    >
                        {currencyFormat(row.ceAdjustments)}
                    </span>
                </Tooltip>)
        }
        else {
            if (!value) return '-';
            return value;
        };
    };

    let maincol = [
        {
            text: <Input type="checkbox" title={allcheckids.length == 0 ? "select all" : "unselect all"} onChange={(e) => { handleAllCheckbox(e) }} hidden={data.length == 0 || hiddencolum == true} checked={allCheckDefault} />,
            cellRenderer: (rowData) => renderCheckbox(rowData),
            width: 30,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true
        },
        {
            dataField: 'organizationName',
            text: 'Organization',
            width: 200,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.organizationName)
        },
        {
            dataField: 'ceName',
            text: 'Covered Entity',
            width: 200,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.ceName)
        },
        {
            dataField: 'fmStatusName',
            text: 'Status',
            width: 170,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.fmStatusName)
        },
        {
            dataField: 'opaCode',
            text: '340B ID',
            width: 120,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.opaCode)
        },
        {
            dataField: 'monthYear',
            text: 'Month Year',
            width: 100,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.monthYear)
        },
        {
            dataField: 'totalClaims',
            text: 'Total Claims Received',
            width: 100,
            show: true,
            inputType: 'number',
            cellRenderer: (row) => cellnumberFormat(row.totalClaims)
        },
        {
            dataField: 'capturedClaims',
            text: 'Captured Claims Count',
            width: 100,
            show: true,
            inputType: 'number',
            cellRenderer: (row) => cellnumberFormat(row.capturedClaims)
        },
        {
            dataField: 'pharmacyPaid',
            text: 'Total Payments Received',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.pharmacyPaid)
        },
        {
            dataField: 'minPFFee',
            text: 'PharmaForce TPA Fee',
            width: 110,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.minPFFee)
        },
        {
            dataField: 'switchFee',
            text: 'Claim Processing',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.switchFee)
        },
        {
            dataField: 'ftFee',
            text: 'Transaction Charge',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.ftFee)
        },
        {
            dataField: 'gatewayFee',
            text: 'Gateway Charge',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.gatewayFee)
        },
        {
            dataField: 'pharmaForceAdjustment',
            text: 'Pharmacy Adjustments',
            width: 110,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.pharmaForceAdjustment)
        },
        {
            dataField: 'cashCardFees',
            text: 'Cashcard Fee',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => cellrendertooltipcashcardfee(row)
        },
        {
            dataField: 'historicalSwitchFees',
            text: 'Historical Switch Fees',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.historicalSwitchFees)
        },
        {
            dataField: 'referralCaptureServiceFees',
            text: 'Referral Capture Service',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.referralCaptureServiceFees)
        },
        {
            dataField: 'splitBillingAdminFees',
            text: 'Split Billing TPA Fee',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.splitBillingAdminFees)
        },
        {
            dataField: 'ceAdjustments',
            text: 'CE Adjustments',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => cellrendertooltipalternatefee(row)
        },
        {
            dataField: 'cpFixedFee',
            text: 'Alternate Fee',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.cpFixedFee)
        },
        {
            dataField: 'totalFees',
            text: 'Total Charges',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.totalFees)
        },
        {
            dataField: 'total340BNetRemitDue',
            text: 'Total 340B Net Remit Due',
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            style_textAlign: { textAlign: "right" },
            cellRenderer: (row) => currencyFormat(row.total340BNetRemitDue)
        }
    ];

    const handleManvalSearch = async () => {
        setSelectedIds([]);
        allcheckids = [];
        checkedIds = [];
        var value = {}
        value.year = yearvalue;
        value.month = monthid;
        value.cstatus = cstatus;

        if (cstatus == "5") {
            hiddencolum = true;
        }
        else {
            hiddencolum = false;

        }
        await manvalsearch(value);
    };

    const handleUpadte = async () => {

        let payloaddata = {};
        payloaddata.PFCEInvoiceID = checkedIds;
        try {
            setLoading(true);
            const { data } = await API.post(`/fm/savebulkupdate/${tostatus}`, payloaddata, {
                hasDefaultURL: false,
            });

            if (data) {

                setLoading(false);
                setAllCheckDefault(false);
                toast.success('Status updated successfully');
                handleManvalSearch();
                refetch();
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handleonReset = async () => {

        fetchStartingYearMonth();
        fetchGetEndingYearMonth();
        setSelectedDate();
        setmaxmonth(new Date(endingyear, endingMonth, 28));
        setSelectedYear(new Date(endingyear, 11, 28));
        fetchStatus();
        setStatusID('-1');
        setCstatus('-1');
        tostatusdata = [];
        bulkReset();
        searchbutton = true;
    };

    const handelsetStatus = async (e) => {

        var statusvalue = e.target.value;
        fetchtoStatus(statusvalue);
        setCstatus(statusvalue);

        if (e.target.value != "") {

            searchbutton = false;
        }
        else {
            searchbutton = true;
        }
    };

    const handelsetToStatus = async (e) => {

        var tostatusvalue = e.target.value;
        setTostatus(tostatusvalue);
    };

    const onChange = (claim) => {

        const { pfceInvoiceID } = claim;
        const index = checkedIds.indexOf(pfceInvoiceID);
        if (checkedIds.length === 0) {
            checkedIds.push(pfceInvoiceID);
        } else {
            if (index >= 0) {
                checkedIds.splice(index, 1);
            } else {
                checkedIds.push(pfceInvoiceID);
            };
        };
        setSelectedIds([...checkedIds]);
    };

    const renderCheckbox = (claim) => {
        if (hiddencolum != true) {
            const filter = selectedIds.filter((item) => item === claim.pfceInvoiceID);
            return (
                <Input
                    onChange={() => onChange(claim)}
                    type='checkbox'
                    className='me-2 mt-0'
                    value={filter.length > 0}
                    checked={filter.length > 0}
                />);
        }

    }
    return (

        <div>
            {(loader || loading) && <Loader opacity={0.01} color='black' />}
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <Label>Current Status</Label>
                        <Input
                            id="currentstatus"
                            name="currentstatus"
                            type='select'
                            value={cstatus}
                            onChange={(e) => {
                                handelsetStatus(e);
                            }}
                        >
                            <option value={''}>--Select--</option>
                            {statusdata.map((status) => {
                                const { value, label } = status;
                                return (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                );
                            })}
                        </Input>
                    </FormGroup>
                </Col>
                <Col md={3} sm={6} xs={6} className="datepicker_info" style={{ zIndex: 99 }}>
                    <FormGroup>
                        <Label for='yearID'>Year</Label>
                        <div id="text">
                            <InputGroup onMouseLeave={handleMouseLeave}>
                                <DatePicker
                                    id="startyear"
                                    selected={selectedyear}
                                    onChange={(date) => handelYear(date)}
                                    onKeyDown={(e) => e.preventDefault()}
                                    dateFormat="yyyy"
                                    minDate={new Date(Startingyear, 0, 1)}
                                    maxDate={new Date(endingyear, 11, 28)}
                                    showYearPicker
                                />
                                <InputGroupText
                                    onClick={() => handleDateClick("startyear")}
                                >
                                    <img src={Calendar} alt='' />
                                </InputGroupText>
                            </InputGroup>
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={6} xs={6} className="datepicker_info" style={{ zIndex: 99, marginLeft: "0px" }} id="text1"
                >
                    <FormGroup>
                        <Label>Month</Label>
                        <div id="text" >
                            <InputGroup onMouseLeave={handleMouseLeave}>
                                <DatePicker
                                    id="startmonth"
                                    onKeyDown={(e) => e.preventDefault()}
                                    selected={selectedDate}
                                    onChange={(date) => formatMonth(date)}
                                    maxDate={maxmont}
                                    dateFormat="MMMM"
                                    autoComplete="off"
                                    showMonthYearPicker
                                    style={{ width: "150px" }}
                                />
                                <InputGroupText
                                    onClick={() => handleDateClick("startmonth")}
                                >
                                    <img src={Calendar} alt='' />
                                </InputGroupText>
                            </InputGroup>
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} style={{ paddingTop: '29px' }}>
                    <Button
                        color='primary'
                        onClick={handleManvalSearch}
                        disabled={searchbutton}
                    >
                        Search
                    </Button>
                    <Button
                        color='primary'
                        onClick={handleonReset}
                    >
                        Reset
                    </Button>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label>To Status</Label>
                        <Input
                            id="tostatus"
                            name="tostatus"
                            type='select'
                            value={tostatus}
                            onChange={(e) => {
                                handelsetToStatus(e);
                            }}
                        >
                            <option value={''}>--Select--</option>
                            {tostatusdata.map((status) => {
                                const { value, label } = status;
                                return (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                );
                            })}
                        </Input>
                    </FormGroup>
                </Col>
                <Col md={3} style={{ paddingTop: '29px' }}>
                    <Button
                        color='primary'
                        onClick={handleUpadte}
                        disabled={!(checkedIds.length != 0 && tostatus > 0)}
                    >
                        Update
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col md={10}>
                    <Label>Selected Count : {checkedIds.length}</Label>
                </Col>
                <Col md={2}>
                    <Label style={{ display: 'flex', justifyContent: 'right' }}>Total Count : {data.length}</Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <div
                            className='table-card filter-table position-relative border-0 '
                            fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
                        >
                            {statusloading && <Loader opacity={0.01} color='black' />}
                            <ReactStrapTable
                                id='invoicenoteslist'
                                columns={maincol}
                                data={data}
                            />
                            <Confirm
                                isOpen={isConfirm}
                                loading={loading}
                                message='Are you sure you want to update?'
                                onToggle={handleManvalSearch}
                                onCancel={handleManvalSearch}
                                onContinue={handleUpadte}
                            />
                        </div>
                    </FormGroup>
                </Col>
            </Row>
        </div>
    );
};
export default BulkUpdateStatus;